// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // api: 'http://127.0.0.1/usbusiness/api',
  // img: 'http://127.0.0.1/usbusiness/api/images',
  // api: 'https://credia.co.th/usbusiness/api',
  // img: 'https://credia.co.th/usbusiness/api/images',
  api: 'https://usbusinessthailand.com/api',
  img: 'https://usbusinessthailand.com/api/images'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
